import { StyleSheet } from 'aphrodite'

import transaction from './transaction'
import list from './list'
import status from './status'

export default {
  list: StyleSheet.create(list),
  transaction: StyleSheet.create(transaction),
  status: StyleSheet.create(status)
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/BillingTable/style/ColorBlind/index.js